package app.emails

import app.layouts.adminMenu
import app.properties.*
import app.settings.backendPath
import kotlinx.html.id
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import kotlinx.html.onChange
import org.w3c.dom.get
import react.*
import react.dom.*
import kotlin.browser.localStorage

interface  EmailsState : RState {
    var emailsList: HashMap<String,String>?
    var newEmail: String?
    var isNewEmailValid: Boolean?
}

class Emails : RComponent<RProps, EmailsState>() {

    init {
        chackLogin()

        axiosGet(backendPath + "/email/list").then {
            updateMailList(it)
        }
    }

    private fun updateMailList(it: dynamic) {
        var listOfEmailHashMap : HashMap<String,String> = hashMapOf()
        it.data.forEach { mail ->
            listOfEmailHashMap.set(mail.id, mail.email)
        }

        setState {
            emailsList = listOfEmailHashMap
        }
    }

    override fun RBuilder.render() {
        if (localStorage["jwt"]!=null) {
            adminMenu()

            div("adminListBlock") {

                div("row") {
                    div("col-4") {
                        input(classes = "form-control") {
                            attrs {
                                value = state.newEmail ?: ""
                                onChangeFunction = {
                                    val email = getTargetValue(it)
                                    setState {
                                        newEmail = email
                                    }
                                }
                                jsStyle {
                                    if (state.isNewEmailValid == false) {
                                        border = "1px solid red"
                                    }
                                }
                            }
                        }
                    }
                    div("col-2") {
                        button(classes = "btn btn-outline-dark") {
                            attrs {
                                onClickFunction = {

                                    if(Credit.emailRegex.containsMatchIn(state?.newEmail ?: "")) {
                                        axiosPost(backendPath+"/email/create", object {
                                            val id = null
                                            val email = state.newEmail
                                        }).then {
                                            updateMailList(it)
                                            setState {
                                                newEmail = null
                                                isNewEmailValid = null
                                            }
                                        }
                                    } else {
                                        setState {
                                            isNewEmailValid = false
                                        }
                                    }
                                }
                            }
                            i("fa fa-plus") {  }
                        }
                    }
                }

                state.emailsList?.forEach {
                    val key  = it.key
                    val email = it.value

                    div("row") {
                        div("col") {
                            input(classes = "form-control") {
                                attrs {
                                    value = email
                                    onChangeFunction = {
                                        val email = getTargetValue(it)
                                        setState {
                                            emailsList?.set(key, email)
                                        }
                                    }
                                }
                            }
                        }
                        div("col-1") {
                            button(classes = "btn btn-outline-dark") {

                                attrs {
                                    onClickFunction = {
                                        if(Credit.emailRegex.containsMatchIn(email)) {
                                            axiosPost(backendPath + "/email/save", object {
                                                val id = key
                                                val email = email
                                            }).then {
                                                js("""new PNotify({
                                                    text: 'Պահպանված է',
                                                    type: 'success',
                                                    styling: 'bootstrap3'
                                                });""")
                                                updateMailList(it)
                                            }
                                        } else {
                                            js("""new PNotify({
                                                    text: 'Ոչ վալիդ էլ․ փոստ',
                                                    type: 'error',
                                                    styling: 'bootstrap3'
                                                });""")
                                        }
                                    }
                                }

                                i("fa fa-save") {}
                            }
                        }
                        div("col-1") {
                            button(classes = "btn btn-outline-dark") {

                                attrs {
                                    onClickFunction = {
                                        if(kotlin.browser.window.confirm("Ջնջել?")) {
                                            axiosPost(backendPath + "/email/delete", object {
                                                val id = key
                                                val email = email
                                            }).then {
                                                updateMailList(it)
                                            }
                                        }
                                    }
                                }

                                i("fa fa-trash-alt") {}
                            }
                        }
                    }
                }
            }
        }
    }

}